<script setup>
import {
	onMounted,
	onUnmounted,
} from 'vue'

import { UUID } from '@/modules/util/uuid'

const id = `app-bar-actions-${(new UUID).get()}`

onMounted(() => {
	const target = document.getElementById('app-bar-actions-target')
	
	if (!target) {
		return
	}

	target.appendChild(document.getElementById(id))
})

onUnmounted(() => {
	const target = document.getElementById('app-bar-actions-target')
	
	if (!target) {
		return
	}

	target.removeChild(document.getElementById(id))
})
</script>

<template>
<div :id="id">
	<slot />
</div>
</template>

<style lang="scss" scoped>

</style>